<template>
    <div class="right_box_main">
        <div class="listBox-item">
            <!-- <div class="mianbao">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/griddingindex' }">网格工作</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/twoNetworkConvergence' }">两网融合</el-breadcrumb-item>
          <el-breadcrumb-item>考勤地图</el-breadcrumb-item>
        </el-breadcrumb>
      </div> -->
            <el-card class="publicCard">
                <div class="fisthang" style="margin-bottom: 20px">
                    <p>
                        今日考勤：正常考勤
                        <el-tag @click="normalKaoQinDetails" type="danger">{{
                            attendanceRecordStatisticsByMap.normalAttendanceNum
                        }}</el-tag
                        >已考勤
                        <el-tag @click="kaoQinDetails" type="danger">{{
                            attendanceRecordStatisticsByMap.attendanceNum
                        }}</el-tag
                        >未考勤
                        <el-tag @click="noKaoQinDetails" type="danger">{{
                            attendanceRecordStatisticsByMap.noAttendanceNum
                        }}</el-tag
                        >异常考勤
                        <el-tag @click="abnormalKaoQinDetails" type="danger">{{
                            attendanceRecordStatisticsByMap.abnormalAttendanceNum
                        }}</el-tag>
                    </p>
                </div>
                <div id="attendanceMapBox">
                    <div
                        style="width: 100%; height: calc(100vh - 240px)"
                        id="attendanceMap"
                    ></div>
                    <!-- <wanggeyaun
            style="width:1920px;position:absolute;z-index:1;top: -100px;height: 700px"
            v-if="wanggeyaunOff"
          ></wanggeyaun>-->
                    <!-- <mapbox style="width:100%; height: calc(100vh - 80px);"></mapbox> -->
                </div>
            </el-card>
        </div>
        <!-- 正常考勤 -->
        <el-dialog
            title="考勤信息"
            :visible.sync="infor1"
            :modal-append-to-body="false"
            width="1500px"
        >
            <!-- <AttendanceDetails v-if="infor"></AttendanceDetails> -->
            <!-- 表格 -->
            <el-card>
                <!-- 搜索框 -->
                <div>
                    <el-form
                        :inline="true"
                        :model="searchlist"
                        class="demo-form-inline"
                    >
                        <el-form-item label="时间">
                            <el-date-picker
                                v-model="time"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                value-format="yyyy-MM-dd HH:mm:ss"
                            ></el-date-picker>
                        </el-form-item>
                        <el-form-item label="姓名">
                            <el-input
                                v-model="searchlist.personName"
                                placeholder
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="所属机构" prop="orgName">
                            <el-cascader
                                ref="myCascader"
                                v-model="orgId"
                                :options="orgList"
                                :props="{ checkStrictly: true }"
                                @change="handleChange"
                                :show-all-levels="false"
                            ></el-cascader>
                        </el-form-item>
                        <el-form-item>
                            <el-button
                                type="primary"
                                @click="searchlistdatazckq"
                                >查询</el-button
                            >
                        </el-form-item>
                        <el-form-item>
                            <el-button type="info" @click="searchlistResetzckq"
                                >重置</el-button
                            >
                        </el-form-item>
                    </el-form>
                </div>
                <!-- 表格主体 -->
                <div class="listBox-item">
                    <div class="table_card">
                        <el-table
                            :data="tableData"
                            :header-cell-style="{ background: '#f8fafa' }"
                            size="small"
                            border
                            align="center"
                            current-row-key
                            highlight-current-row
                        >
                            <!-- <el-table-column align="center" type="selection" width="35"></el-table-column> -->
                            <el-table-column
                                align="center"
                                prop="personName"
                                label="用户名"
                            ></el-table-column>
                            <el-table-column
                                align="center"
                                prop="orgName"
                                label="组织机构"
                            ></el-table-column>
                            <el-table-column
                                align="center"
                                prop="morningSignInTime"
                                label="上午签到时间"
                            ></el-table-column>
                            <el-table-column
                                align="center"
                                prop="morningSignInAttendanceType"
                                label="上午签到状态"
                            >
                                <template slot-scope="scope">
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignInAttendanceType ==
                                            1
                                        "
                                        >正常</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignInAttendanceType ==
                                            2
                                        "
                                        >迟到</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignInAttendanceType ==
                                            3
                                        "
                                        >早退</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignInAttendanceType ==
                                            4
                                        "
                                        >迟到+早退</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignInAttendanceType ==
                                            5
                                        "
                                        >请假</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignInAttendanceType ==
                                            6
                                        "
                                        >加班</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignInAttendanceType ==
                                            7
                                        "
                                        >补卡</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignInAttendanceType ==
                                            8
                                        "
                                        >换班</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignInAttendanceType ==
                                            9
                                        "
                                        >外出</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignInAttendanceType ==
                                            10
                                        "
                                        >缺卡</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignInAttendanceType ==
                                            11
                                        "
                                        >旷工</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignInAttendanceType ==
                                            12
                                        "
                                        >外勤</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignInAttendanceType ==
                                            13
                                        "
                                        >异常</span
                                    >
                                </template>
                            </el-table-column>
                            <el-table-column
                                align="center"
                                prop="morningSignInLocation"
                                label="上午签到位置"
                            ></el-table-column>

                            <el-table-column
                                align="center"
                                prop="morningSignOffTime"
                                label="上午签退时间"
                            ></el-table-column>

                            <el-table-column
                                align="center"
                                prop="morningSignOffAttendanceType"
                                label="上午签退状态"
                            >
                                <template slot-scope="scope">
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignOffAttendanceType ==
                                            1
                                        "
                                        >正常</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignOffAttendanceType ==
                                            2
                                        "
                                        >迟到</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignOffAttendanceType ==
                                            3
                                        "
                                        >早退</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignOffAttendanceType ==
                                            4
                                        "
                                        >迟到+早退</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignOffAttendanceType ==
                                            5
                                        "
                                        >请假</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignOffAttendanceType ==
                                            6
                                        "
                                        >加班</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignOffAttendanceType ==
                                            7
                                        "
                                        >补卡</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignOffAttendanceType ==
                                            8
                                        "
                                        >换班</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignOffAttendanceType ==
                                            9
                                        "
                                        >外出</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignOffAttendanceType ==
                                            10
                                        "
                                        >缺卡</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignOffAttendanceType ==
                                            11
                                        "
                                        >旷工</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignOffAttendanceType ==
                                            12
                                        "
                                        >外勤</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignOffAttendanceType ==
                                            13
                                        "
                                        >异常</span
                                    >
                                </template>
                            </el-table-column>
                            <el-table-column
                                align="center"
                                prop="morningSignOffLocation"
                                label="上午签退位置"
                            ></el-table-column>
                            <el-table-column
                                align="center"
                                prop="afternoonSignInTime"
                                label="下午签到时间"
                            ></el-table-column>
                            <el-table-column
                                align="center"
                                prop="afternoonSignInAttendanceType"
                                label="下午签到状态"
                            >
                                <template slot-scope="scope">
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignInAttendanceType ==
                                            1
                                        "
                                        >正常</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignInAttendanceType ==
                                            2
                                        "
                                        >迟到</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignInAttendanceType ==
                                            3
                                        "
                                        >早退</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignInAttendanceType ==
                                            4
                                        "
                                        >迟到+早退</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignInAttendanceType ==
                                            5
                                        "
                                        >请假</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignInAttendanceType ==
                                            6
                                        "
                                        >加班</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignInAttendanceType ==
                                            7
                                        "
                                        >补卡</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignInAttendanceType ==
                                            8
                                        "
                                        >换班</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignInAttendanceType ==
                                            9
                                        "
                                        >外出</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignInAttendanceType ==
                                            10
                                        "
                                        >缺卡</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignInAttendanceType ==
                                            11
                                        "
                                        >旷工</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignInAttendanceType ==
                                            12
                                        "
                                        >外勤</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignInAttendanceType ==
                                            13
                                        "
                                        >异常</span
                                    >
                                </template>
                            </el-table-column>
                            <el-table-column
                                align="center"
                                prop="afternoonSignInLocation"
                                label="下午签到位置"
                            ></el-table-column>

                            <el-table-column
                                align="center"
                                prop="afternoonSignOffTime"
                                label="下午签退时间"
                            ></el-table-column>

                            <el-table-column
                                align="center"
                                prop="afternoonSignOffAttendanceType"
                                label="下午签退状态"
                            >
                                <template slot-scope="scope">
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignOffAttendanceType ==
                                            1
                                        "
                                        >正常</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignOffAttendanceType ==
                                            2
                                        "
                                        >迟到</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignOffAttendanceType ==
                                            3
                                        "
                                        >早退</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignOffAttendanceType ==
                                            4
                                        "
                                        >迟到+早退</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignOffAttendanceType ==
                                            5
                                        "
                                        >请假</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignOffAttendanceType ==
                                            6
                                        "
                                        >加班</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignOffAttendanceType ==
                                            7
                                        "
                                        >补卡</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignOffAttendanceType ==
                                            8
                                        "
                                        >换班</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignOffAttendanceType ==
                                            9
                                        "
                                        >外出</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignOffAttendanceType ==
                                            10
                                        "
                                        >缺卡</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignOffAttendanceType ==
                                            11
                                        "
                                        >旷工</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignOffAttendanceType ==
                                            12
                                        "
                                        >外勤</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignOffAttendanceType ==
                                            13
                                        "
                                        >异常</span
                                    >
                                </template>
                            </el-table-column>
                            <el-table-column
                                align="center"
                                prop="afternoonSignOffLocation"
                                label="下午签退位置"
                            ></el-table-column>
                        </el-table>
                        <!-- 分页 -->
                        <el-pagination
                            :page-size="pageConfig.pageSize"
                            layout="total, prev, pager, next, jumper"
                            @current-change="handleCurrentChange"
                            :total="pageConfig.total"
                        ></el-pagination>
                        <!-- <el-button type="primary">确定</el-button>
            <el-button type="info">取消</el-button>-->
                    </div>
                </div>
            </el-card>
        </el-dialog>
        <!-- 已考勤 -->
        <el-dialog
            title="考勤信息"
            :visible.sync="infor2"
            :modal-append-to-body="false"
            width="1500px"
        >
            <!-- <AttendanceDetails v-if="infor"></AttendanceDetails> -->
            <!-- 表格 -->
            <el-card>
                <!-- 搜索框 -->
                <div>
                    <el-form
                        :inline="true"
                        :model="searchlist"
                        class="demo-form-inline"
                    >
                        <el-form-item label="时间">
                            <el-date-picker
                                v-model="time"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                value-format="yyyy-MM-dd HH:mm:ss"
                            ></el-date-picker>
                        </el-form-item>
                        <el-form-item label="姓名">
                            <el-input
                                v-model="searchlist.personName"
                                placeholder
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="所属机构" prop="orgName">
                            <el-cascader
                                ref="myCascader"
                                v-model="orgId"
                                :options="orgList"
                                :props="{ checkStrictly: true }"
                                @change="handleChange"
                                :show-all-levels="false"
                            ></el-cascader>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="searchlistdataykq"
                                >查询</el-button
                            >
                        </el-form-item>
                        <el-form-item>
                            <el-button type="info" @click="searchlistResetykq"
                                >重置</el-button
                            >
                        </el-form-item>
                    </el-form>
                </div>
                <!-- 表格主体 -->
                <div class="listBox-item">
                    <div class="table_card">
                        <el-table
                            :data="tableData"
                            :header-cell-style="{ background: '#f8fafa' }"
                            size="small"
                            border
                            align="center"
                            current-row-key
                            highlight-current-row
                        >
                            <!-- <el-table-column align="center" type="selection" width="35"></el-table-column> -->
                            <el-table-column
                                align="center"
                                prop="personName"
                                label="用户名"
                            ></el-table-column>
                            <el-table-column
                                align="center"
                                prop="orgName"
                                label="组织机构"
                            ></el-table-column>
                            <el-table-column
                                align="center"
                                prop="morningSignInTime"
                                label="上午签到时间"
                            ></el-table-column>
                            <el-table-column
                                align="center"
                                prop="morningSignInAttendanceType"
                                label="上午签到状态"
                            >
                                <template slot-scope="scope">
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignInAttendanceType ==
                                            1
                                        "
                                        >正常</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignInAttendanceType ==
                                            2
                                        "
                                        >迟到</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignInAttendanceType ==
                                            3
                                        "
                                        >早退</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignInAttendanceType ==
                                            4
                                        "
                                        >迟到+早退</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignInAttendanceType ==
                                            5
                                        "
                                        >请假</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignInAttendanceType ==
                                            6
                                        "
                                        >加班</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignInAttendanceType ==
                                            7
                                        "
                                        >补卡</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignInAttendanceType ==
                                            8
                                        "
                                        >换班</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignInAttendanceType ==
                                            9
                                        "
                                        >外出</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignInAttendanceType ==
                                            10
                                        "
                                        >缺卡</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignInAttendanceType ==
                                            11
                                        "
                                        >旷工</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignInAttendanceType ==
                                            12
                                        "
                                        >外勤</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignInAttendanceType ==
                                            13
                                        "
                                        >异常</span
                                    >
                                </template>
                            </el-table-column>
                            <el-table-column
                                align="center"
                                prop="morningSignInLocation"
                                label="上午签到位置"
                            ></el-table-column>
                            <el-table-column
                                align="center"
                                prop="morningSignOffTime"
                                label="上午签退时间"
                            ></el-table-column>

                            <el-table-column
                                align="center"
                                prop="morningSignOffAttendanceType"
                                label="上午签退状态"
                            >
                                <template slot-scope="scope">
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignOffAttendanceType ==
                                            1
                                        "
                                        >正常</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignOffAttendanceType ==
                                            2
                                        "
                                        >迟到</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignOffAttendanceType ==
                                            3
                                        "
                                        >早退</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignOffAttendanceType ==
                                            4
                                        "
                                        >迟到+早退</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignOffAttendanceType ==
                                            5
                                        "
                                        >请假</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignOffAttendanceType ==
                                            6
                                        "
                                        >加班</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignOffAttendanceType ==
                                            7
                                        "
                                        >补卡</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignOffAttendanceType ==
                                            8
                                        "
                                        >换班</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignOffAttendanceType ==
                                            9
                                        "
                                        >外出</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignOffAttendanceType ==
                                            10
                                        "
                                        >缺卡</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignOffAttendanceType ==
                                            11
                                        "
                                        >旷工</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignOffAttendanceType ==
                                            12
                                        "
                                        >外勤</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignOffAttendanceType ==
                                            13
                                        "
                                        >异常</span
                                    >
                                </template>
                            </el-table-column>

                            <el-table-column
                                align="center"
                                prop="morningSignOffLocation"
                                label="上午签退位置"
                            ></el-table-column>
                            <el-table-column
                                align="center"
                                prop="afternoonSignInTime"
                                label="下午签到时间"
                            ></el-table-column>
                            <el-table-column
                                align="center"
                                prop="afternoonSignInAttendanceType"
                                label="下午签到状态"
                            >
                                <template slot-scope="scope">
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignInAttendanceType ==
                                            1
                                        "
                                        >正常</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignInAttendanceType ==
                                            2
                                        "
                                        >迟到</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignInAttendanceType ==
                                            3
                                        "
                                        >早退</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignInAttendanceType ==
                                            4
                                        "
                                        >迟到+早退</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignInAttendanceType ==
                                            5
                                        "
                                        >请假</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignInAttendanceType ==
                                            6
                                        "
                                        >加班</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignInAttendanceType ==
                                            7
                                        "
                                        >补卡</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignInAttendanceType ==
                                            8
                                        "
                                        >换班</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignInAttendanceType ==
                                            9
                                        "
                                        >外出</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignInAttendanceType ==
                                            10
                                        "
                                        >缺卡</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignInAttendanceType ==
                                            11
                                        "
                                        >旷工</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignInAttendanceType ==
                                            12
                                        "
                                        >外勤</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignInAttendanceType ==
                                            13
                                        "
                                        >异常</span
                                    >
                                </template>
                            </el-table-column>
                            <el-table-column
                                align="center"
                                prop="afternoonSignInLocation"
                                label="下午签到位置"
                            ></el-table-column>
                            <el-table-column
                                align="center"
                                prop="afternoonSignOffTime"
                                label="下午签退时间"
                            ></el-table-column>

                            <el-table-column
                                align="center"
                                prop="afternoonSignOffAttendanceType"
                                label="下午签退状态"
                            >
                                <template slot-scope="scope">
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignOffAttendanceType ==
                                            1
                                        "
                                        >正常</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignOffAttendanceType ==
                                            2
                                        "
                                        >迟到</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignOffAttendanceType ==
                                            3
                                        "
                                        >早退</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignOffAttendanceType ==
                                            4
                                        "
                                        >迟到+早退</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignOffAttendanceType ==
                                            5
                                        "
                                        >请假</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignOffAttendanceType ==
                                            6
                                        "
                                        >加班</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignOffAttendanceType ==
                                            7
                                        "
                                        >补卡</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignOffAttendanceType ==
                                            8
                                        "
                                        >换班</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignOffAttendanceType ==
                                            9
                                        "
                                        >外出</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignOffAttendanceType ==
                                            10
                                        "
                                        >缺卡</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignOffAttendanceType ==
                                            11
                                        "
                                        >旷工</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignOffAttendanceType ==
                                            12
                                        "
                                        >外勤</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignOffAttendanceType ==
                                            13
                                        "
                                        >异常</span
                                    >
                                </template>
                            </el-table-column>

                            <el-table-column
                                align="center"
                                prop="afternoonSignOffLocation"
                                label="下午签退位置"
                            ></el-table-column>
                        </el-table>
                        <!-- 分页 -->
                        <el-pagination
                            :page-size="pageConfig.pageSize"
                            layout="total, prev, pager, next, jumper"
                            @current-change="handleCurrentChange"
                            :total="pageConfig.total"
                        ></el-pagination>
                        <!-- <el-button type="primary">确定</el-button>
            <el-button type="info">取消</el-button>-->
                    </div>
                </div>
            </el-card>
        </el-dialog>
        <!-- 未考勤 -->
        <el-dialog
            title="考勤信息"
            :visible.sync="infor3"
            :modal-append-to-body="false"
            width="1500px"
        >
            <!-- 表格 -->
            <el-card>
                <!-- 搜索框 -->
                <div>
                    <el-form
                        :inline="true"
                        :model="searchlist"
                        class="demo-form-inline"
                    >
                        <!-- <el-form-item label="时间" >
              <el-date-picker
                v-model="time"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd HH:mm:ss"
              ></el-date-picker>
            </el-form-item>-->
                        <el-form-item label="姓名">
                            <el-input
                                v-model="searchlist.personName"
                                placeholder
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="所属机构" prop="orgName">
                            <el-cascader
                                ref="myCascader"
                                v-model="orgId"
                                :options="orgList"
                                :props="{ checkStrictly: true }"
                                @change="handleChange"
                                :show-all-levels="false"
                            ></el-cascader>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="searchlistdatawkq"
                                >查询</el-button
                            >
                        </el-form-item>
                        <el-form-item>
                            <el-button type="info" @click="searchlistResetwkq"
                                >重置</el-button
                            >
                        </el-form-item>
                    </el-form>
                </div>
                <!-- 表格主体 -->
                <div class="listBox-item">
                    <div class="table_card">
                        <el-table
                            :data="tableData"
                            :header-cell-style="{ background: '#f8fafa' }"
                            size="small"
                            border
                            align="center"
                            current-row-key
                            highlight-current-row
                        >
                            <!-- <el-table-column align="center" type="selection" width="35"></el-table-column> -->
                            <el-table-column
                                align="center"
                                prop="personName"
                                label="用户名"
                            ></el-table-column>
                            <el-table-column
                                align="center"
                                prop="orgName"
                                label="组织机构"
                            ></el-table-column>
                        </el-table>
                        <!-- 分页 -->
                        <el-pagination
                            :page-size="pageConfig.pageSize"
                            layout="total, prev, pager, next, jumper"
                            @current-change="handleCurrentChange"
                            :total="pageConfig.total"
                        ></el-pagination>
                        <!-- <el-button type="primary">确定</el-button>
            <el-button type="info">取消</el-button>-->
                    </div>
                </div>
            </el-card>
        </el-dialog>
        <!-- 异常考勤 -->
        <el-dialog
            title="考勤信息"
            :visible.sync="infor4"
            :modal-append-to-body="false"
            width="1500px"
        >
            <!-- <AttendanceDetails v-if="infor"></AttendanceDetails> -->
            <!-- 表格 -->
            <el-card>
                <!-- 搜索框 -->
                <div>
                    <el-form
                        :inline="true"
                        :model="searchlist"
                        class="demo-form-inline"
                    >
                        <el-form-item label="时间">
                            <el-date-picker
                                v-model="time"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                value-format="yyyy-MM-dd HH:mm:ss"
                            ></el-date-picker>
                        </el-form-item>
                        <el-form-item label="姓名">
                            <el-input
                                v-model="searchlist.personName"
                                placeholder
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="所属机构" prop="orgName">
                            <el-cascader
                                ref="myCascader"
                                v-model="orgId"
                                :props="{ checkStrictly: true }"
                                :options="orgList"
                                @change="handleChange"
                                :show-all-levels="false"
                            ></el-cascader>
                        </el-form-item>
                        <el-form-item>
                            <el-button
                                type="primary"
                                @click="searchlistdatayckq"
                                >查询</el-button
                            >
                        </el-form-item>
                        <el-form-item>
                            <el-button type="info" @click="searchlistResetyckq"
                                >重置</el-button
                            >
                        </el-form-item>
                    </el-form>
                </div>
                <!-- 表格主体 -->
                <div class="listBox-item">
                    <div class="table_card">
                        <el-table
                            :data="tableData"
                            :header-cell-style="{ background: '#f8fafa' }"
                            size="small"
                            border
                            align="center"
                            current-row-key
                            highlight-current-row
                        >
                            <!-- <el-table-column align="center" type="index" width="35"></el-table-column> -->
                            <el-table-column
                                align="center"
                                prop="personName"
                                label="用户名"
                            ></el-table-column>
                            <el-table-column
                                align="center"
                                prop="orgName"
                                label="组织机构"
                            ></el-table-column>
                            <el-table-column
                                align="center"
                                prop="morningSignInTime"
                                label="上午签到时间"
                            ></el-table-column>
                            <el-table-column
                                align="center"
                                prop="morningSignInAttendanceType"
                                label="上午签到状态"
                            >
                                <template slot-scope="scope">
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignInAttendanceType ==
                                            1
                                        "
                                        >正常</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignInAttendanceType ==
                                            2
                                        "
                                        >迟到</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignInAttendanceType ==
                                            3
                                        "
                                        >早退</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignInAttendanceType ==
                                            4
                                        "
                                        >迟到+早退</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignInAttendanceType ==
                                            5
                                        "
                                        >请假</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignInAttendanceType ==
                                            6
                                        "
                                        >加班</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignInAttendanceType ==
                                            7
                                        "
                                        >补卡</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignInAttendanceType ==
                                            8
                                        "
                                        >换班</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignInAttendanceType ==
                                            9
                                        "
                                        >外出</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignInAttendanceType ==
                                            10
                                        "
                                        >缺卡</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignInAttendanceType ==
                                            11
                                        "
                                        >旷工</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignInAttendanceType ==
                                            12
                                        "
                                        >外勤</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignInAttendanceType ==
                                            13
                                        "
                                        >异常</span
                                    >
                                </template>
                            </el-table-column>
                            <el-table-column
                                align="center"
                                prop="morningSignInLocation"
                                label="上午签到位置"
                            ></el-table-column>
                            <el-table-column
                                align="center"
                                prop="morningSignOffTime"
                                label="上午签退时间"
                            ></el-table-column>

                            <el-table-column
                                align="center"
                                prop="morningSignOffAttendanceType"
                                label="上午签退状态"
                            >
                                <template slot-scope="scope">
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignOffAttendanceType ==
                                            1
                                        "
                                        >正常</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignOffAttendanceType ==
                                            2
                                        "
                                        >迟到</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignOffAttendanceType ==
                                            3
                                        "
                                        >早退</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignOffAttendanceType ==
                                            4
                                        "
                                        >迟到+早退</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignOffAttendanceType ==
                                            5
                                        "
                                        >请假</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignOffAttendanceType ==
                                            6
                                        "
                                        >加班</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignOffAttendanceType ==
                                            7
                                        "
                                        >补卡</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignOffAttendanceType ==
                                            8
                                        "
                                        >换班</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignOffAttendanceType ==
                                            9
                                        "
                                        >外出</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignOffAttendanceType ==
                                            10
                                        "
                                        >缺卡</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignOffAttendanceType ==
                                            11
                                        "
                                        >旷工</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignOffAttendanceType ==
                                            12
                                        "
                                        >外勤</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .morningSignOffAttendanceType ==
                                            13
                                        "
                                        >异常</span
                                    >
                                </template>
                            </el-table-column>

                            <el-table-column
                                align="center"
                                prop="morningSignOffLocation"
                                label="上午签退位置"
                            ></el-table-column>
                            <el-table-column
                                align="center"
                                prop="afternoonSignInTime"
                                label="下午签到时间"
                            ></el-table-column>
                            <el-table-column
                                align="center"
                                prop="afternoonSignInAttendanceType"
                                label="下午签到状态"
                            >
                                <template slot-scope="scope">
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignInAttendanceType ==
                                            1
                                        "
                                        >正常</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignInAttendanceType ==
                                            2
                                        "
                                        >迟到</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignInAttendanceType ==
                                            3
                                        "
                                        >早退</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignInAttendanceType ==
                                            4
                                        "
                                        >迟到+早退</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignInAttendanceType ==
                                            5
                                        "
                                        >请假</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignInAttendanceType ==
                                            6
                                        "
                                        >加班</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignInAttendanceType ==
                                            7
                                        "
                                        >补卡</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignInAttendanceType ==
                                            8
                                        "
                                        >换班</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignInAttendanceType ==
                                            9
                                        "
                                        >外出</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignInAttendanceType ==
                                            10
                                        "
                                        >缺卡</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignInAttendanceType ==
                                            11
                                        "
                                        >旷工</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignInAttendanceType ==
                                            12
                                        "
                                        >外勤</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignInAttendanceType ==
                                            13
                                        "
                                        >异常</span
                                    >
                                </template>
                            </el-table-column>
                            <el-table-column
                                align="center"
                                prop="afternoonSignInLocation"
                                label="下午签到位置"
                            ></el-table-column>
                            <el-table-column
                                align="center"
                                prop="afternoonSignOffTime"
                                label="下午签退时间"
                            ></el-table-column>

                            <el-table-column
                                align="center"
                                prop="afternoonSignOffAttendanceType"
                                label="下午签退状态"
                            >
                                <template slot-scope="scope">
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignOffAttendanceType ==
                                            1
                                        "
                                        >正常</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignOffAttendanceType ==
                                            2
                                        "
                                        >迟到</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignOffAttendanceType ==
                                            3
                                        "
                                        >早退</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignOffAttendanceType ==
                                            4
                                        "
                                        >迟到+早退</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignOffAttendanceType ==
                                            5
                                        "
                                        >请假</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignOffAttendanceType ==
                                            6
                                        "
                                        >加班</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignOffAttendanceType ==
                                            7
                                        "
                                        >补卡</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignOffAttendanceType ==
                                            8
                                        "
                                        >换班</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignOffAttendanceType ==
                                            9
                                        "
                                        >外出</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignOffAttendanceType ==
                                            10
                                        "
                                        >缺卡</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignOffAttendanceType ==
                                            11
                                        "
                                        >旷工</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignOffAttendanceType ==
                                            12
                                        "
                                        >外勤</span
                                    >
                                    <span
                                        v-if="
                                            tableData[scope.$index]
                                                .afternoonSignOffAttendanceType ==
                                            13
                                        "
                                        >异常</span
                                    >
                                </template>
                            </el-table-column>

                            <el-table-column
                                align="center"
                                prop="afternoonSignOffLocation"
                                label="下午签退位置"
                            ></el-table-column>
                        </el-table>
                        <!-- 分页 -->
                        <el-pagination
                            :page-size="pageConfig.pageSize"
                            layout="total, prev, pager, next, jumper"
                            @current-change="handleCurrentChange"
                            :total="pageConfig.total"
                        ></el-pagination>
                        <!-- <el-button type="primary">确定</el-button>
            <el-button type="info">取消</el-button>-->
                    </div>
                </div>
            </el-card>
        </el-dialog>
    </div>
</template>

<script>
import { post, attendanceRecordStatisticsByMap } from "./api/index"
import { tabdata } from "@/mixins/tabledataMixKaoQin.js"
import { validatePhoneOrMobile } from "@/utils/validate.js"
import orgListSelect from "@/component/orgListSelect/index.vue"
// import mapbox from "../gridding/tissueDitu/dataCentreindextest.vue";
// import wanggeyaun from "./wanggeyaunmap.vue";
import NoAttendanceNum from "./attendanceDetails.vue"

let infoWindow
let map
export default {
    mixins: [tabdata],
    components: { orgListSelect, NoAttendanceNum },
    data() {
        return {
            attendanceRecordStatisticsByMapParams: {
                orgId: null,
                orgLevel: null,
            }, //获取考勤地图参数
            attendanceRecordStatisticsByMap: {
                attendanceNum: 0, //应出勤人数
                normalAttendanceNum: 0, //正常出勤人数
                noAttendanceNum: 0, //缺勤人数
                abnormalAttendanceNum: 0, //异常出勤人数
            }, //考勤地图数据
            add: {
                form: {
                    orgId: "",
                },
                off: false,
            },
            type: "",
            orgList: [],
            wanggeyaunOff: false,
            infor1: false,
            infor2: false,
            infor3: false,
            infor4: false,
            userOptions: [],
            tableData: [],
            tableDataUrl: "",
            time: "",
            orgId: "",
            orgLevel: "",
            searchlist: {
                personName: "",
                orgName: "",
            },
        }
    },
    methods: {
        //获取考勤地图数据
        async getAttendanceRecordStatisticsByMap() {
            let that = this
            that.attendanceRecordStatisticsByMapParams.orgId = localStorage.getItem(
                "orgId"
            )
                ? localStorage.getItem("orgId")
                : 0
            that.attendanceRecordStatisticsByMapParams.orgLevel = localStorage.getItem(
                "orgLevel"
            )
                ? localStorage.getItem("orgLevel")
                : 0
            let data = await attendanceRecordStatisticsByMap(
                that.attendanceRecordStatisticsByMapParams
            )
            if (data.code && data.code == 200) {
                // let datanum = null
                // if(that.content && data.content.length>0) datanum = data.content[0]
                if (data.content[0] != null && data.content[0].attendanceNum)
                    that.attendanceRecordStatisticsByMap.attendanceNum =
                        data.content[0].attendanceNum
                if (
                    data.content[0] != null &&
                    data.content[0].normalAttendanceNum
                )
                    that.attendanceRecordStatisticsByMap.normalAttendanceNum =
                        data.content[0].normalAttendanceNum
                if (data.content[0] != null && data.content[0].noAttendanceNum)
                    that.attendanceRecordStatisticsByMap.noAttendanceNum =
                        data.content[0].noAttendanceNum
                if (
                    data.content[0] != null &&
                    data.content[0].abnormalAttendanceNum
                )
                    that.attendanceRecordStatisticsByMap.abnormalAttendanceNum =
                        data.content[0].abnormalAttendanceNum
                console.log("data.content[0]:", data.content[0])
            }
            console.log("attendanceRecordStatisticsByMap结果data:", data)
        },
        // 考勤点击事件
        // 正常考勤
        normalKaoQinDetails() {
            this.searchlist = {}
            this.time = ""
            this.pageConfig.pageNo = 1
            this.orgName = ""
            this.orgId = ""
            post("/admin/attendanceRecord/info/list", {
                pageNo: 1,
                pageSize: 99,
                attendanceMapType: 1,
            }).then((res) => {
                console.log(res.content.list == null)
                console.log(res.content.list == "")
                console.log(typeof res.content.list)
                if (res.content.list == "") {
                    this.infor1 = false
                    this.pageConfig.total = 0
                    this.tableData = []
                } else {
                    this.searchlist = {}
                    this.tableData = res.content.list
                    this.pageConfig.total = res.content.count
                    this.infor1 = true
                }
            })
        },
        // 已考勤
        kaoQinDetails() {
            this.searchlist = {}
            this.time = ""
            this.pageConfig.pageNo = 1
            this.orgName = ""
            this.orgId = ""
            post("/admin/attendanceRecord/info/list", {
                pageNo: 1,
                pageSize: 999,
                attendanceMapType: 2,
            }).then((res) => {
                if (res.content.list == "") {
                    this.infor2 = false
                    this.pageConfig.total = 0
                    this.tableData = []
                } else {
                    this.searchlist = {}
                    this.tableData = res.content.list
                    this.pageConfig.total = res.content.count
                    this.infor2 = true
                }
            })
        },
        // 未考勤
        noKaoQinDetails() {
            this.searchlist = {}
            this.time = ""
            this.pageConfig.pageNo = 1
            this.orgName = ""
            this.orgId = ""
            post("/admin/attendanceRecord/info/list", {
                pageNo: 1,
                pageSize: 999,
                attendanceMapType: 3,
            }).then((res) => {
                if (res.content.list == "") {
                    this.infor3 = false
                    this.pageConfig.total = 0
                    this.tableData = []
                } else {
                    this.searchlist = {}
                    this.pageConfig.total = res.content.count
                    this.tableData = res.content.list
                    this.infor3 = true
                }
            })
        },
        // 异常考勤
        abnormalKaoQinDetails() {
            this.searchlist = {}
            this.time = ""
            this.pageConfig.pageNo = 1
            this.orgName = ""
            this.orgId = ""
            post("/admin/attendanceRecord/info/list", {
                pageNo: 1,
                pageSize: 999,
                attendanceMapType: 4,
            }).then((res) => {
                if (res.content.list == "") {
                    this.infor4 = false
                    this.pageConfig.total = 0
                    this.tableData = []
                } else {
                    this.searchlist = {}
                    this.pageConfig.total = res.content.count
                    this.tableData = res.content.list
                    this.infor4 = true
                }
            })
        },
        // 正常考勤查询
        searchlistdatazckq() {
            this.pageConfig.pageNo = 1
            post("/admin/attendanceRecord/info/list", {
                pageNo: 1,
                pageSize: 999,
                attendanceMapType: 1,
                ...this.pageConfig,
                ...this.searchlist,
                orgId: this.orgId,
                orgLevel: this.orgLevel,
                startTime: this.time[0] ? this.time[0] : "",
                endTime: this.time[1] ? this.time[1] : "",
            }).then((res) => {
                if (res.content.list == "") {
                    this.pageConfig.total = 0
                    this.tableData = []
                } else {
                    this.pageConfig.total = res.content.count
                    this.tableData = res.content.list
                }
            })
        },
        // 正常考勤重置
        searchlistResetzckq() {
            this.searchlist = {}
            this.time = ""
            this.pageConfig.pageNo = 1
            this.orgName = ""
            this.orgId = ""
            post("/admin/attendanceRecord/info/list", {
                pageNo: 1,
                pageSize: 999,
                attendanceMapType: 1,
                ...this.pageConfig,
                ...this.searchlist,
                orgId: this.orgId,
                startTime: this.time[0] ? this.time[0] : "",
                endTime: this.time[1] ? this.time[1] : "",
            }).then((res) => {
                if (res.content.list == "") {
                    this.pageConfig.total = 0
                    this.tableData = []
                } else {
                    this.pageConfig.total = res.content.count
                    this.tableData = res.content.list
                }
            })
        },
        // 已考勤查询
        searchlistdataykq() {
            this.pageConfig.pageNo = 1
            post("/admin/attendanceRecord/info/list", {
                pageNo: 1,
                pageSize: 999,
                attendanceMapType: 2,
                ...this.pageConfig,
                ...this.searchlist,
                orgId: this.orgId,
                orgLevel: this.orgLevel,
                startTime: this.time[0] ? this.time[0] : "",
                endTime: this.time[1] ? this.time[1] : "",
            }).then((res) => {
                if (res.content.list == "") {
                    this.pageConfig.total = 0
                    this.tableData = []
                } else {
                    this.pageConfig.total = res.content.count
                    this.tableData = res.content.list
                }
            })
        },
        // 已考勤重置
        searchlistResetykq() {
            this.searchlist = {}
            this.time = ""
            this.pageConfig.pageNo = 1
            this.orgName = ""
            this.orgId = ""
            post("/admin/attendanceRecord/info/list", {
                pageNo: 1,
                pageSize: 999,
                attendanceMapType: 2,
                ...this.pageConfig,
                ...this.searchlist,
                orgId: this.orgId,
                startTime: this.time[0] ? this.time[0] : "",
                endTime: this.time[1] ? this.time[1] : "",
            }).then((res) => {
                if (res.content.list == "") {
                    this.pageConfig.total = 0
                    this.tableData = []
                } else {
                    this.pageConfig.total = res.content.count
                    this.tableData = res.content.list
                }
            })
        },
        // 未考勤查询
        searchlistdatawkq() {
            this.pageConfig.pageNo = 1
            post("/admin/attendanceRecord/info/list", {
                pageNo: 1,
                pageSize: 999,
                attendanceMapType: 3,
                ...this.pageConfig,
                ...this.searchlist,
                orgId: this.orgId,
                orgLevel: this.orgLevel,
                startTime: this.time[0] ? this.time[0] : "",
                endTime: this.time[1] ? this.time[1] : "",
            }).then((res) => {
                if (res.content.list == "") {
                    this.pageConfig.total = 0
                    this.tableData = []
                } else {
                    this.pageConfig.total = res.content.count
                    this.tableData = res.content.list
                }
            })
        },
        // 未考勤重置
        searchlistResetwkq() {
            this.searchlist = {}
            this.time = ""
            this.pageConfig.pageNo = 1
            this.orgName = ""
            this.orgId = ""
            post("/admin/attendanceRecord/info/list", {
                pageNo: 1,
                pageSize: 999,
                attendanceMapType: 3,
                ...this.pageConfig,
                ...this.searchlist,
                orgId: this.orgId,
                startTime: this.time[0] ? this.time[0] : "",
                endTime: this.time[1] ? this.time[1] : "",
            }).then((res) => {
                if (res.content.list == "") {
                    this.pageConfig.total = 0
                    this.tableData = []
                } else {
                    this.pageConfig.total = res.content.count
                    this.tableData = res.content.list
                }
            })
        },
        // 异常考勤查询
        searchlistdatayckq() {
            this.pageConfig.pageNo = 1
            post("/admin/attendanceRecord/info/list", {
                pageNo: 1,
                pageSize: 999,
                attendanceMapType: 4,
                ...this.pageConfig,
                ...this.searchlist,
                orgId: this.orgId,
                orgLevel: this.orgLevel,
                startTime: this.time[0] ? this.time[0] : "",
                endTime: this.time[1] ? this.time[1] : "",
            }).then((res) => {
                if (res.content.list == "") {
                    this.pageConfig.total = 0
                    this.tableData = []
                } else {
                    this.pageConfig.total = res.content.count
                    this.tableData = res.content.list
                }
            })
        },
        // 异常考勤重置
        searchlistResetyckq() {
            this.searchlist = {}
            this.time = ""
            this.pageConfig.pageNo = 1
            this.orgName = ""
            this.orgId = ""
            post("/admin/attendanceRecord/info/list", {
                pageNo: 1,
                pageSize: 999,
                attendanceMapType: 4,
                ...this.pageConfig,
                ...this.searchlist,
                orgId: this.orgId,
                startTime: this.time[0] ? this.time[0] : "",
                endTime: this.time[1] ? this.time[1] : "",
            }).then((res) => {
                if (res.content.list == "") {
                    this.pageConfig.total = 0
                    this.tableData = []
                } else {
                    this.pageConfig.total = res.content.count
                    this.tableData = res.content.list
                }
            })
        },
        // 所属机构
        handleChange(value) {
            console.log(value, this.$refs.myCascader.getCheckedNodes()[0].level)
            console.log(
                value,
                this.$refs.myCascader.getCheckedNodes()[0].data.orgLevel
            )
            this.orgLevel = this.$refs.myCascader.getCheckedNodes()[0].data.orgLevel
            if (value != null) {
                this.orgId = value[value.length - 1]
            }
        },
    },
    async mounted() {
        var that = this
        // 地图初始化
        map = new AMap.Map("attendanceMap", {
            layers: [
                //只显示默认图层的时候，layers可以缺省
                new AMap.TileLayer(), //高德默认标准图层
            ],
            mapStyle: "amap://styles/darkblue",
            zoom: 15,
            zooms: [3, 20],
            expandZoomRange: true,
            // center: [117.494476, 30.64932] //初始化地图中心点
            center: [118.006294, 32.779161], //初始化地图中心点
        })
        // 绘制网格
        // post("/admin/org/info/findZdOrg", {}).then((res) => {
        //     console.log(res)
        //     res.content.forEach((item) => {
        //         let polygonArr = []
        //         if (item.pointPosition) {
        //             item.pointPosition.split(",").forEach((e) => {
        //                 polygonArr.push(e.split(":"))
        //             })
        //             var polygon = new AMap.Polygon({
        //                 map: map,
        //                 path: polygonArr, //设置多边形边界路径
        //                 strokeColor: "#" + item.gridColour, //线颜色
        //                 strokeOpacity: 0.2, //线透明度
        //                 strokeWeight: 3, //线宽
        //                 fillColor: "#" + item.gridColour, //填充色
        //                 fillOpacity: 0.35, //填充透明度
        //                 extData: {
        //                     name: item.orgName,
        //                 },
        //             })
        //             //点击事件
        //             polygon.on("click", function (e) {
        //                 // that.$emit("setOrgId", item.id);
        //             })
        //             //变色
        //             polygon.on("mouseover", function () {
        //                 this.setOptions({
        //                     strokeOpacity: 0.8, //线透明度
        //                     strokeWeight: 3, //线宽
        //                     fillOpacity: 0.5, //填充透明度
        //                 })
        //             })
        //             polygon.on("mouseout", function () {
        //                 this.setOptions({
        //                     strokeOpacity: 0.2, //线透明度
        //                     strokeWeight: 3, //线宽
        //                     fillOpacity: 0.35, //填充透明度
        //                 })
        //             })
        //         }
        //     })
        // })
        // var mouseTool = new AMap.MouseTool(map);
        //监听draw事件可获取画好的覆盖物
        var overlays = []
        // 添加点标记
        // 1获取考勤点坐标  2给坐标添加名字和图片 3添加信息窗体 4渲染考勤数据
        var cluster,
            markers = []
        post("/admin/attendanceRecord/info/list", {
            pageNo: 1,
            pageSize: 999,
        }).then((res) => {
            console.log(res)
            res.content.list.forEach((item) => {
                console.log(item)
                console.log(item.id)
                // console.log(item.morningSignInTime)//上午签到时间
                // console.log(item.morningSignOffTime)//上午签退时间
                // console.log(item.afternoonSignInTime)//下午签到时间
                // console.log(item.afternoonSignOffTime)//下午签退时间
                // console.log(item.morningSignInAttendanceType)//上午签到状态
                // console.log(item.morningSignOffAttendanceType)//上午签退状态
                // console.log(item.afternoonSignInAttendanceType)//下午签到状态
                // console.log(item.afternoonSignOffAttendanceType)//下午签退状态
                //  console.log(item.morningSignInLocation)//上午签到位置
                // console.log(item.morningSignOffLocation)//上午签退位置
                // console.log(item.afternoonSignInLocation)//下午签到位置
                // console.log(item.afternoonSignOffLocation)//下午签退位置
                // // console.log(item.personName)
                // // console.log(item.morningSignInLongitude)//上午签到打卡的经度
                // // console.log(item.morningSignInLatitude)//上午签到打卡的经度
                // // console.log(item.morningSignOffLongitude)//上午签退打卡的经度
                // // console.log(item.morningSignOffLatitude)//上午签退打卡的经度
                // // console.log(item.afternoonSignInLongitude)//下午签到打卡的经度
                // // console.log(item.afternoonSignInLatitude)//下午签到打卡的经度
                // // console.log(item.afternoonSignOffLongitude)//下午签退打卡的经度
                // // console.log(item.afternoonSignOffLatitude)//下午签退打卡的经度
                // <span v-if="tableData[scope.$index].morningSignOffAttendanceType==1">正常</span>
                //             <span v-if="tableData[scope.$index].morningSignOffAttendanceType==2">迟到</span>
                //             <span v-if="tableData[scope.$index].morningSignOffAttendanceType==3">早退</span>
                //             <span v-if="tableData[scope.$index].morningSignOffAttendanceType==4">迟到+早退</span>
                //             <span v-if="tableData[scope.$index].morningSignOffAttendanceType==5">请假</span>
                //             <span v-if="tableData[scope.$index].morningSignOffAttendanceType==6">加班</span>
                //             <span v-if="tableData[scope.$index].morningSignOffAttendanceType==7">补卡</span>
                //             <span v-if="tableData[scope.$index].morningSignOffAttendanceType==8">换班</span>
                //             <span v-if="tableData[scope.$index].morningSignOffAttendanceType==9">外出</span>
                //             <span v-if="tableData[scope.$index].morningSignOffAttendanceType==10">缺卡</span>
                //             <span v-if="tableData[scope.$index].morningSignOffAttendanceType==11">旷工</span>
                //             <span v-if="tableData[scope.$index].morningSignOffAttendanceType==12">外勤</span>
                //             <span v-if="tableData[scope.$index].morningSignOffAttendanceType==13">异常</span>
                // 上午签到状态
                if (item.morningSignInAttendanceType == 1) {
                    item.morningSignInAttendanceType = "正常"
                } else if (item.morningSignInAttendanceType == 2) {
                    item.morningSignInAttendanceType = "迟到"
                } else if (item.morningSignInAttendanceType == 3) {
                    item.morningSignInAttendanceType = "早退"
                } else if (item.morningSignInAttendanceType == 4) {
                    item.morningSignInAttendanceType = "迟到+早退"
                } else if (item.morningSignInAttendanceType == 5) {
                    item.morningSignInAttendanceType = "请假"
                } else if (item.morningSignInAttendanceType == 6) {
                    item.morningSignInAttendanceType = "加班"
                } else if (item.morningSignInAttendanceType == 7) {
                    item.morningSignInAttendanceType = "补卡"
                } else if (item.morningSignInAttendanceType == 8) {
                    item.morningSignInAttendanceType = "换班"
                } else if (item.morningSignInAttendanceType == 9) {
                    item.morningSignInAttendanceType = "外出"
                } else if (item.morningSignInAttendanceType == 10) {
                    item.morningSignInAttendanceType = "缺卡"
                } else if (item.morningSignInAttendanceType == 11) {
                    item.morningSignInAttendanceType = "旷工"
                } else if (item.morningSignInAttendanceType == 12) {
                    item.morningSignInAttendanceType = "外勤"
                } else if (item.morningSignInAttendanceType == 13) {
                    item.morningSignInAttendanceType = "异常"
                } else if (item.morningSignInAttendanceType == 0) {
                    item.morningSignInAttendanceType = "无"
                }
                // 上午签退状态
                if (item.morningSignOffAttendanceType == 1) {
                    item.morningSignOffAttendanceType = "正常"
                } else if (item.morningSignOffAttendanceType == 2) {
                    item.morningSignOffAttendanceType = "迟到"
                } else if (item.morningSignOffAttendanceType == 3) {
                    item.morningSignOffAttendanceType = "早退"
                } else if (item.morningSignOffAttendanceType == 4) {
                    item.morningSignOffAttendanceType = "迟到+早退"
                } else if (item.morningSignOffAttendanceType == 5) {
                    item.morningSignOffAttendanceType = "请假"
                } else if (item.morningSignOffAttendanceType == 6) {
                    item.morningSignOffAttendanceType = "加班"
                } else if (item.morningSignOffAttendanceType == 7) {
                    item.morningSignOffAttendanceType = "补卡"
                } else if (item.morningSignOffAttendanceType == 8) {
                    item.morningSignOffAttendanceType = "换班"
                } else if (item.morningSignOffAttendanceType == 9) {
                    item.morningSignOffAttendanceType = "外出"
                } else if (item.morningSignOffAttendanceType == 10) {
                    item.morningSignOffAttendanceType = "缺卡"
                } else if (item.morningSignOffAttendanceType == 11) {
                    item.morningSignOffAttendanceType = "旷工"
                } else if (item.morningSignOffAttendanceType == 12) {
                    item.morningSignOffAttendanceType = "外勤"
                } else if (item.morningSignOffAttendanceType == 13) {
                    item.morningSignOffAttendanceType = "异常"
                } else if (item.morningSignOffAttendanceType == 0) {
                    item.morningSignOffAttendanceType = "无"
                }
                //下午签到状态
                if (item.afternoonSignInAttendanceType == 1) {
                    item.afternoonSignInAttendanceType = "正常"
                } else if (item.afternoonSignInAttendanceType == 2) {
                    item.afternoonSignInAttendanceType = "迟到"
                } else if (item.afternoonSignInAttendanceType == 3) {
                    item.afternoonSignInAttendanceType = "早退"
                } else if (item.afternoonSignInAttendanceType == 4) {
                    item.afternoonSignInAttendanceType = "迟到+早退"
                } else if (item.afternoonSignInAttendanceType == 5) {
                    item.afternoonSignInAttendanceType = "请假"
                } else if (item.afternoonSignInAttendanceType == 6) {
                    item.afternoonSignInAttendanceType = "加班"
                } else if (item.afternoonSignInAttendanceType == 7) {
                    item.afternoonSignInAttendanceType = "补卡"
                } else if (item.afternoonSignInAttendanceType == 8) {
                    item.afternoonSignInAttendanceType = "换班"
                } else if (item.afternoonSignInAttendanceType == 9) {
                    item.afternoonSignInAttendanceType = "外出"
                } else if (item.afternoonSignInAttendanceType == 10) {
                    item.afternoonSignInAttendanceType = "缺卡"
                } else if (item.afternoonSignInAttendanceType == 11) {
                    item.afternoonSignInAttendanceType = "旷工"
                } else if (item.afternoonSignInAttendanceType == 12) {
                    item.afternoonSignInAttendanceType = "外勤"
                } else if (item.afternoonSignInAttendanceType == 13) {
                    item.afternoonSignInAttendanceType = "异常"
                } else if (item.afternoonSignInAttendanceType == 0) {
                    item.afternoonSignInAttendanceType = "无"
                }
                //下午签退状态
                if (item.afternoonSignOffAttendanceType == 1) {
                    item.afternoonSignOffAttendanceType = "正常"
                } else if (item.afternoonSignOffAttendanceType == 2) {
                    item.afternoonSignOffAttendanceType = "迟到"
                } else if (item.afternoonSignOffAttendanceType == 3) {
                    item.afternoonSignOffAttendanceType = "早退"
                } else if (item.afternoonSignOffAttendanceType == 4) {
                    item.afternoonSignOffAttendanceType = "迟到+早退"
                } else if (item.afternoonSignOffAttendanceType == 5) {
                    item.afternoonSignOffAttendanceType = "请假"
                } else if (item.afternoonSignOffAttendanceType == 6) {
                    item.afternoonSignOffAttendanceType = "加班"
                } else if (item.afternoonSignOffAttendanceType == 7) {
                    item.afternoonSignOffAttendanceType = "补卡"
                } else if (item.afternoonSignOffAttendanceType == 8) {
                    item.afternoonSignOffAttendanceType = "换班"
                } else if (item.afternoonSignOffAttendanceType == 9) {
                    item.afternoonSignOffAttendanceType = "外出"
                } else if (item.afternoonSignOffAttendanceType == 10) {
                    item.afternoonSignOffAttendanceType = "缺卡"
                } else if (item.afternoonSignOffAttendanceType == 11) {
                    item.afternoonSignOffAttendanceType = "旷工"
                } else if (item.afternoonSignOffAttendanceType == 12) {
                    item.afternoonSignOffAttendanceType = "外勤"
                } else if (item.afternoonSignOffAttendanceType == 13) {
                    item.afternoonSignOffAttendanceType = "异常"
                } else if (item.afternoonSignOffAttendanceType == 0) {
                    item.afternoonSignOffAttendanceType = "无"
                }
                let location = []
                let nowlocation = ""
                let nowtime = ""
                if (
                    item.afternoonSignOffLongitude !== null ||
                    item.afternoonSignOffLatitude !== null
                ) {
                    nowlocation = item.afternoonSignOffLocation
                    nowtime = item.afternoonSignOffTime
                    location.push(
                        item.afternoonSignOffLongitude,
                        item.afternoonSignOffLatitude
                    )
                } else if (
                    item.afternoonSignInLongitude !== null ||
                    item.afternoonSignInLatitude !== null
                ) {
                    nowlocation = item.afternoonSignInLocation
                    nowtime = item.afternoonSignInTime
                    location.push(
                        item.afternoonSignInLongitude,
                        item.afternoonSignInLatitude
                    )
                } else if (
                    item.morningSignOffLongitude !== null ||
                    item.morningSignOffLatitude !== null
                ) {
                    nowlocation = item.morningSignOffLocation
                    nowtime = item.morningSignOffTime
                    location.push(
                        item.morningSignOffLongitude,
                        item.morningSignOffLatitude
                    )
                } else if (
                    item.morningSignInLongitude !== null ||
                    item.morningSignInLatitude !== null
                ) {
                    nowlocation = item.morningSignInLocation
                    nowtime = item.morningSignInTime
                    location.push(
                        item.morningSignInLongitude,
                        item.morningSignInLatitude
                    )
                }
                console.log(nowlocation)
                let m = new AMap.Marker({
                    position: location,
                    content:
                        "<p>" +
                        item.personName +
                        '</p><svg t="1587952328306" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1311" width="32" height="32"><path d="M768.579 668.846c-24.876-24.876-89.719-40.348-129.598-47.739a514.907 514.907 0 0 1 5.813 5.75l24.641 76.001-26.866 25.721 21.074 45.864L630.396 963.5h71.906l3.228-98.451 5.66 98.451h93.671c-1.752-77-8.758-267.126-36.282-294.654zM380.624 728.565l-26.871-25.74 24.642-76.031s2.229-2.231 5.864-5.677c-39.935 7.453-104.112 23.014-128.833 47.729C227.902 696.374 220.892 886.5 219.14 963.5h90.283l5.658-98.451 3.227 98.451h74.485l-33.24-189.067 21.071-45.868z" fill="#8198C8" p-id="1312"></path><path d="M437.608 588.48a362.253 362.253 0 0 1 1.6-5.242 178.502 178.502 0 0 0-1.6 5.242z" fill="#FFCFBA" p-id="1313"></path><path d="M481.77 626.794l30.229 55.313 29.421-55.313s26.08-13.438 38.08-33.745v-42.492c-12 21.974-34.099 34.123-74.371 34.123-38.519 0-55.629-11.316-72.629-31.865v28.286c9-0.378 4.349-0.796 5.205-1.099 2.338 26.905 44.065 46.792 44.065 46.792z" fill="#FFCFBA" p-id="1314"></path><path d="M505.129 584.68c40.272 0 62.371-12.149 74.371-34.123v-4.04c-16 18.99-34.318 29.395-71.615 29.395-40.295 0-52.385-12.383-75.385-34.783v11.687c17 20.547 34.111 31.864 72.629 31.864z" fill="#F4B4A7" p-id="1315"></path><path d="M309.423 963.5h8.885l-3.227-98.451zM702.302 963.5h8.888l-5.66-98.451z" fill="#78829A" p-id="1316"></path><path d="M596.029 645.745l-24.776 43.63s-4.677-55.563-28.66-62.581L512 682.107l-30.229-55.313c-23.979 7.018-28.662 62.581-28.662 62.581l-25.039-44.102c-1.509 20.367-1.723 44.086-0.697 71.845 1.053 28.273 24.009 136.382 49.057 246.382h75.119c22.529-110 43.223-218.108 44.271-246.382 1.021-27.704 1.235-51.219 0.209-71.373z" fill="#FFFFFF" p-id="1317"></path><path d="M428.07 645.273l-1.86-3.278c1.629-18.759 7.804-41.465 11.398-53.515 0.51-1.771 1.046-3.52 1.6-5.242 0.645-2.052 1.04-3.236 1.04-3.236-0.854 0.303-1.771 0.721-2.665 1.099-17.713 7.489-42.235 29.521-53.323 40.017-3.635 3.445-5.864 5.677-5.864 5.677l-24.642 76.031 26.871 25.74-21.07 45.867 33.24 189.067h83.636c-25.047-110-48.003-218.108-49.057-246.382-1.027-27.759-0.813-51.477 0.696-71.845z" fill="#848FC1" p-id="1318"></path><path d="M585.144 580.845c0.104 0.305 0.194 0.623 0.296 0.927 0.028-0.253 0.108-0.494 0.134-0.754-0.143-0.049-0.294-0.126-0.43-0.173z" fill="#3B433F" p-id="1319"></path><path d="M642.569 728.565l26.866-25.74-24.641-76.031s-2.193-2.28-5.813-5.818c-11.088-10.822-35.748-33.548-53.396-39.949 0.103 0.343 10.248 34.202 12.571 60.969l-2.128 3.75c1.026 20.154 0.813 43.669-0.209 71.373-1.048 28.273-21.741 136.382-44.271 246.382H630.395l33.247-189.067-21.073-45.869z" fill="#848FC1" p-id="1320"></path><path d="M440.247 580.002s-0.396 1.185-1.04 3.236a379.586 379.586 0 0 0-1.6 5.242c-3.594 12.05-9.769 34.756-11.398 53.515l1.86 3.278 25.039 44.102s4.682-55.563 28.662-62.581c0 0-39.185-19.887-41.523-46.792zM542.592 626.794c23.983 7.018 28.66 62.581 28.66 62.581l24.776-43.63 2.128-3.75c-2.323-26.767-12.506-60.626-12.607-60.969 0-0.005-0.049-0.03-0.049-0.03v0.021c0 0.26-0.07 0.501-0.098 0.754-0.451 3.955-1.73 7.713-3.572 11.277-10.488 20.307-39.238 33.746-39.238 33.746z" fill="#BFBFBF" p-id="1321"></path><path d="M511.6 575.911c37.295 0 55.62-10.404 70.247-29.395 10.15-13.174 18.518-30.48 30.201-51.321 7.764-13.84 13.727-29.525 18.264-45.721 3.296 0.817 6.903-0.022 10.726-3.405 11.923-10.523 24.927-61.414 16.149-71.934-2.957-3.569-6.123-4.31-9.008-3.747a330.635 330.635 0 0 1-1.919 12.674c-0.245 1.45-0.54 2.916-0.809 4.377a340.172 340.172 0 0 1-1.644 8.484c-0.122 0.612-0.217 1.207-0.348 1.814-0.011-0.034-0.019 0.772-0.027 0.741-1.423 6.677-3.001 17.021-4.814 21.021h-3.681c2.128-18 3.587-48.408-1.412-71.728-8.662-40.358-38.055-74.985-60.272-71.483-21.917 3.468-39.29 13.543-61.67 13.806-22.385-0.263-39.759-10.651-61.681-14.123-22.213-3.501-51.607 31.493-60.266 71.854-5.005 23.32-3.542 53.675-1.418 71.675h-3.677c-2.61-9-4.771-20.212-6.556-29.714-0.005 0.021-0.009-0.375-0.013-0.358-0.171-0.882-0.306-1.967-0.467-2.854a421.652 421.652 0 0 1-1.018-5.9 300.783 300.783 0 0 1-1.511-10.235c-2.883-0.563-6.043 0.154-9.008 3.725-8.777 10.519 4.231 61.394 16.149 71.917 3.827 3.382 7.444 4.216 10.735 3.396 4.545 16.202 10.514 31.883 18.277 45.725 10.159 18.115 17.887 33.547 26.452 45.926 15.494 22.4 33.726 34.783 74.019 34.783z" fill="#FFCFBA" p-id="1322"></path><path d="M377.505 386.369c0.157 0.858 0.318 2.555 0.48 3.417 1.785 9.502 3.945 20.714 6.556 29.714h3.677c-2.124-18-3.587-48.408 1.418-71.728 8.659-40.358 38.053-74.985 60.266-71.483 21.922 3.468 39.296 13.543 61.681 13.806 22.38-0.263 39.753-10.651 61.67-14.123 22.218-3.501 51.61 31.493 60.272 71.854 4.999 23.32 3.54 53.675 1.412 71.675h3.681c1.813-4 3.392-14.343 4.814-21.021 0.121-0.568 0.256-1.566 0.375-2.14 0.596-2.833 1.127-5.873 1.644-8.694 0.269-1.459 0.563-3.028 0.809-4.479a332.927 332.927 0 0 0 1.919-12.727c5.158-39.742 2.115-76.155-11.381-105.065-21.152-45.317-81.427-64.666-125.215-64.924-43.803 0.258-104.073 19.59-125.226 64.902-13.496 28.915-16.539 65.296-11.381 105.042 0.436 3.368 0.957 6.765 1.511 10.176 0.315 1.923 0.673 3.858 1.018 5.798z" fill="#323232" p-id="1323"></path><path d="M680.683 304.681c0 46.189-0.479 124.096-165.227 124.096-164.771 0-165.214-77.907-165.214-124.096 0-46.15 74.015-56.628 165.214-56.628 91.242 0 165.227 10.478 165.227 56.628z" fill="#686F79" p-id="1324"></path><path d="M515.456 423.365c-158.762 0-164.959-72.299-165.214-118.888v0.207c0 46.188 0.442 124.096 165.214 124.096 164.747 0 165.227-77.907 165.227-124.096v-0.207c-0.286 46.587-6.483 118.888-165.227 118.888z" fill="#686F79" p-id="1325"></path><path d="M753.058 199.494c0 46.914-106.915 84.964-238.769 84.964-131.776 0-238.661-38.05-238.661-84.964 0-46.929 144.74-138.908 238.661-138.908 93.995 0 238.769 91.978 238.769 138.908z" fill="#AAB1BD" p-id="1326"></path><path d="M514.289 87.451c65.482 0 163.265 55.935 179.727 91.711 1.583-3.291 2.434-6.658 2.434-10.087 0-34.226-110.455-101.299-182.16-101.299-71.638 0-182.056 67.073-182.056 101.299 0 3.429 0.852 6.795 2.399 10.087 16.463-35.776 114.214-91.711 179.656-91.711z" fill="#AAB1BD" p-id="1327"></path><path d="M638.335 95.664c39.82 23.673 70.124 52.461 70.124 71.838 0 38.143-86.909 69.079-194.17 69.079-107.194 0-194.067-30.937-194.067-69.079 0-19.378 30.276-48.166 70.125-71.838-62.25 31.007-114.718 75.591-114.718 103.83 0 46.914 106.887 84.964 238.661 84.964 131.854 0 238.769-38.05 238.769-84.964-0.001-28.239-52.466-72.824-114.724-103.83z" fill="#686F79" p-id="1328"></path><path d="M692.565 254.767v-0.095c-0.032-0.079-0.063-0.17-0.095-0.253 0-0.026-0.066-0.06-0.066-0.06-6.003-14.319-82.895-25.649-176.949-25.649-94.011 0-170.962 11.33-176.937 25.649 0 0-0.025 0.033-0.025 0.06-0.038 0.083-0.1 0.173-0.127 0.253 0 0.022-0.031 0.064-0.031 0.095-4.14 9.168-4.266 42.238-0.224 50.95 0.028 0.088 0.16 0.17 0.224 0.278 4.359 14.535 82.009 26.104 177.122 26.104 95.13 0 172.743-11.57 177.142-26.104 0.059-0.109 0.161-0.19 0.194-0.278 4.036-8.713 3.969-41.782-0.228-50.95z" fill="#444B54" p-id="1329"></path><path d="M695.753 281.124c-0.067-2.178-0.123-4.323-0.256-6.43h0.036c-0.036-0.384-0.098-0.729-0.128-1.125 0-0.284-0.03-0.583-0.059-0.883v0.015c-0.163-2.136-0.346-4.186-0.603-6.062-10.687 2.556-24.113 5.023-40.009 7.17-0.256-5.04-4.396-9.065-9.479-9.065-5.247 0-9.519 4.26-9.519 9.507v1.845c-32.302 3.484-72.713 5.773-120.282 5.773-47.554 0-87.941-2.29-120.237-5.773v-1.845c0-5.249-4.301-9.507-9.548-9.507-5.12 0-9.228 4.026-9.48 9.065-15.931-2.146-29.324-4.614-40.037-7.17a133.814 133.814 0 0 0-0.602 6.062v-0.015c-0.035 0.3-0.035 0.6-0.066 0.883-0.029 0.396-0.07 0.741-0.07 1.125-0.12 2.104-0.183 4.251-0.248 6.43 11.598 3.997 25.442 7.774 41.019 11.14 0.129 5.114 4.326 9.229 9.48 9.229 3.86 0 7.201-2.334 8.666-5.655 35.514 6.395 77.674 10.585 121.122 10.585 43.432 0 85.625-4.188 121.132-10.585 1.459 3.322 4.812 5.655 8.669 5.655 5.176 0 9.287-4.115 9.508-9.229 15.555-3.366 29.43-7.143 40.991-11.14z m-40.985 2.889v-2.041a566.326 566.326 0 0 0 21.483-3.3c-6.561 1.836-13.739 3.623-21.483 5.341z m-278.606-2.039v2.041c-7.716-1.719-14.951-3.504-21.525-5.34a591.255 591.255 0 0 0 21.525 3.299z m19.057 5.893v-3.647c36.179 3.814 78.552 5.753 120.237 5.753 41.654 0 84.071-1.94 120.283-5.753v3.647c-33.207 6.09-74.131 10.479-120.283 10.479-46.133 0-87.058-4.389-120.237-10.479z" fill="#444B54" p-id="1330"></path><path d="M338.334 268.249c0-0.038 0.031-0.07 0.031-0.075 0.027-0.083 0.089-0.192 0.127-0.278 0-0.009 0.025-0.027 0.025-0.058 5.975-14.313 82.925-25.626 176.937-25.626 94.053 0 170.944 11.313 176.949 25.626 0 0.029 0.066 0.049 0.066 0.058 0.032 0.085 0.063 0.195 0.095 0.278v0.075c1.705 3.677 2.688 11.283 3.063 19.575 0.571-12.548-0.474-27.395-3.063-33.057v-0.095c-0.032-0.079-0.063-0.17-0.095-0.253 0-0.026-0.066-0.06-0.066-0.06-6.003-14.319-82.895-25.649-176.949-25.649-94.011 0-170.962 11.33-176.937 25.649 0 0-0.025 0.033-0.025 0.06-0.038 0.083-0.1 0.173-0.127 0.253 0 0.022-0.031 0.064-0.031 0.095-2.56 5.661-3.571 20.509-3.035 33.057 0.346-8.295 1.389-15.901 3.035-19.575z" fill="#444B54" p-id="1331"></path><path d="M692.792 292.234c-0.033 0.078-0.136 0.174-0.194 0.267-4.398 14.54-82.012 26.131-177.142 26.131-95.113 0-172.763-11.591-177.122-26.131-0.064-0.092-0.194-0.188-0.222-0.267-1.551-3.317-2.499-10.178-2.813-17.875-0.507 12.283 0.41 26.138 2.813 31.357 0.025 0.088 0.158 0.17 0.222 0.278 4.359 14.535 82.009 26.104 177.122 26.104 95.13 0 172.743-11.57 177.142-26.104 0.059-0.109 0.161-0.19 0.194-0.278 2.394-5.219 3.374-19.074 2.838-31.357-0.349 7.697-1.301 14.558-2.838 17.875z" fill="#444B54" p-id="1332"></path><path d="M695.753 278.436c-0.067-2.887-0.153-5.735-0.406-8.45-35.363 12.496-99.875 25.643-179.891 25.643s-144.515-13.147-179.904-25.643a174.5 174.5 0 0 0-0.381 8.45c40.419 13.924 108.651 25.286 180.285 25.286 71.617 0 139.911-11.363 180.297-25.286z" fill="#F5BF33" p-id="1333"></path><path d="M695.533 271.993c-0.216-2.863-0.443-5.578-0.789-8.059-34.071 8.164-95.593 15.25-179.288 15.25-83.678 0-145.266-7.086-179.302-15.25-0.284 2.481-0.602 5.195-0.736 8.059 41.627 10.083 111.852 15.278 180.038 15.278 68.177 0 138.43-5.195 180.077-15.278z" fill="#F5BF33" p-id="1334"></path><path d="M395.219 289.279c0 5.261-4.301 9.511-9.548 9.511a9.488 9.488 0 0 1-9.507-9.511v-17.725a9.497 9.497 0 0 1 9.507-9.504c5.248 0 9.548 4.268 9.548 9.504v17.725zM635.74 289.279c0 5.261 4.271 9.511 9.518 9.511a9.506 9.506 0 0 0 9.509-9.511v-17.725c0-5.236-4.263-9.504-9.509-9.504-5.247 0-9.518 4.268-9.518 9.504v17.725z" fill="#F5BF33" p-id="1335"></path><path d="M577.339 156.689c0 34.792-28.215 63-63.049 63-34.759 0-62.977-28.208-62.977-63 0-34.79 28.218-63.016 62.977-63.016 34.834 0 63.049 28.225 63.049 63.016z" fill="#444B54" p-id="1336"></path><path d="M515.477 137.086l6.367 12.902 14.236 2.069-10.299 10.04 2.429 14.179-12.733-6.694-12.735 6.694 2.435-14.179-10.303-10.04 14.236-2.069z" fill="#F5BF33" p-id="1337"></path></svg>',
                    offset: new AMap.Pixel(-15, -15),
                    extData: {
                        name: item.personName,
                        morningSignInTime: item.morningSignInTime,
                        morningSignOffTime: item.morningSignOffTime,
                        afternoonSignInTime: item.afternoonSignInTime,
                        afternoonSignOffTime: item.afternoonSignOffTime,
                        morningSignInAttendanceType:
                            item.morningSignInAttendanceType,
                        morningSignOffAttendanceType:
                            item.morningSignOffAttendanceType,
                        afternoonSignInAttendanceType:
                            item.afternoonSignInAttendanceType,
                        afternoonSignOffAttendanceType:
                            item.afternoonSignOffAttendanceType,
                        morningSignInLocation: item.morningSignInLocation,
                        morningSignOffLocation: item.morningSignOffLocation,
                        afternoonSignInLocation: item.afternoonSignInLocation,
                        afternoonSignOffLocation: item.afternoonSignOffLocation,
                        id: item.id,
                    },
                })
                //  m.setMap(map);
                console.log(m)
                markers.push(m)
                console.log(markers)
                map.plugin(["AMap.MarkerClusterer"], function () {
                    cluster = new AMap.MarkerClusterer(map, markers, {
                        gridSize: 1,
                    })
                })
                map.setFitView()
                //给点标记添加click事件
                m.on("click", function (e) {
                    // console.log(e)
                    let data = this.getExtData()
                    console.log(data)
                    for (let x in data) {
                        if (data[x] == null) {
                            data[x] = ""
                        }
                    }
                    var info = `<div class="yybf" style="width: 644px;height: 539px;background: #0a1c30;opacity: 0.8;overflow:hidden;position: absolute;left: 0;top: 0;padding:0px 0px 0px -6px;">
    </div><div class='mapUserInfoBox' style="overflow:hidden; width: 616px; height: 519px;background: #091e47;position: relative; color:#ffffff">
    <div style="position: absolute; left: 10px;top: 30px;"><svg t="1594462880145" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4417" width="25" height="25"><path d="M511.3 342.2c-44.1 0-80 35.9-80 80s35.9 80 80 80 80-35.9 80-80-35.8-80-80-80z" p-id="4418" fill="#ffffff"></path><path d="M728.5 133.6c-2.2-1.6-4.5-3-6.8-4.5-1.2-1.1-2.5-2-3.9-2.9-3-1.9-6-3.7-9-5.5l-4.9-2.9c-23.9-14.2-49.3-25.7-75.4-34.2l-3.9-1.2c-7.4-2.3-15-4.5-23.5-6.6l-3.9-0.9c-9.2-2.1-17.6-3.8-25-5-0.4-0.1-1.2-0.2-1.7-0.3-9.1-1.4-18.6-2.5-28.1-3.3l-4.2-0.3c-7.5-0.5-15.1-0.8-22.8-0.9-2.8-0.2-5.5-0.1-8.3 0h-1.2l-9.9 0.3c-4.9 0.2-9.7 0.5-14.7 0.9l-5.3 0.5c-6.3 0.6-12.6 1.3-19.6 2.3-12.8 1.9-24.1 4-34.6 6.6-1.7 0.4-3.3 0.9-5 1.6-16 4.1-31.3 9.1-45.7 14.8-33 13.2-64 31.1-92.3 53.2-1.4 0.8-2.7 1.7-3.9 2.7-89.8 72.1-141.4 179.5-141.4 294.6 0 89.8 32.2 176.9 90.6 245.2 0.3 0.4 0.6 0.7 1 1.1 2.5 2.7 24.1 25.9 37.1 37.5l223.1 223.1c7.1 7.1 16.5 10.7 25.8 10.7s18.7-3.6 25.8-10.7L760 726.4c13.1-11.6 34.7-34.8 37.1-37.5 0.3-0.4 0.7-0.7 1-1.1 58.4-68.3 90.6-155.4 90.6-245.2 0.2-122.7-59.8-238.2-160.2-309zM511.3 575.4c-84.4 0-153.1-68.7-153.1-153.1 0-84.4 68.7-153.1 153.1-153.1 84.4 0 153.1 68.7 153.1 153.1 0.1 84.4-68.6 153.1-153.1 153.1z" p-id="4419" fill="#ffffff"></path></svg></div>
            <div class="dkLocation" style="padding-top: 30px;padding-left: 50px;">${nowlocation}</div>
            <div class="dktime" style="padding-top: 5px;padding-left: 50px;">${nowtime}</div>
            <div class="dkmorning">

                <table border="0" cellpadding="4" cellspacing="12" align="center" class="qdtable">
                    <th align="center" style="width: 58px">
                        <button class="morningbtn" style="margin: 0;padding: 0;border: 1px solid transparent;outline: none;background-color: #003790;color: #ffffff;width: 57px;height: 30px;">上午</button>
                    </th>
                    <th align="left">时间</th>
                    <th align="left">地点</th>
                    <th align="left" style="width: 50px;">状态</th>
                    <tr>
                        <td style="height:50px;display: flex;justify-content: center;align-items: center"><div class="signin" style="width: 50px;height: 50px;line-height: 50px;border-radius: 50%;background-color: #172c64;text-align: center;font-size:15px;">签到</div></td>
                        <td style="background: #172d64;height:32px;">${data.morningSignInTime}</td>
                        <td style="background: #172d64;height:32px;">${data.morningSignInLocation}</td>
                        <td style="background: #172d64;height:32px;text-align: center;">${data.morningSignInAttendanceType}</td>
                    </tr>
                    <tr>
                        <td style="height:50px;display: flex;justify-content: center;align-items: center"><div class="signoff" style="width: 50px;height: 50px;line-height: 50px;border-radius: 50%;background-color: #172c64;text-align: center; font-size:15px;">签退</div></td>
                        <td style="background: #172d64;height:32px;">${data.morningSignOffTime}</td>
                        <td style="background: #172d64;height:32px;">${data.morningSignOffLocation}</td>
                        <td style="background: #172d64;height:32px;text-align: center;">${data.morningSignOffAttendanceType}</td>
                    </tr>
                </table>
            </div>
            <div class="dkafternoon">
                <table border="0" cellpadding="4" cellspacing="12" align="center" class="qdtable">
                    <th align="center" style="width: 58px">
                        <button class="affernoonbtn" style="margin: 0;padding: 0;border: 1px solid transparent;outline: none;background-color: #003790;color: #ffffff;width: 57px;height: 33px;">下午</button>
                    </th>
                    <th align="left">时间</th>
                    <th align="left">地点</th>
                    <th align="left" style="width: 50px">状态</th>
                    <tr>
                        <td style="height:50px;display: flex;justify-content: center;align-items: center"><div class="signinxw" style="width: 50px;height: 50px;line-height: 50px;border-radius: 50%;background-color: #172c64;text-align: center;font-size:15px;">签到</div></td>
                        <td style="background: #172d64;height:32px;">${data.afternoonSignInTime}</td>
                        <td style="background: #172d64;height:32px;">${data.afternoonSignInLocation}</td>
                        <td style="background: #172d64;height:32px;text-align: center;"">${data.afternoonSignInAttendanceType}</td>
                    </tr>
                    <tr>
                        <td style="height:50px;display: flex;justify-content: center;align-items: center"><div class="signoffxw" style="width: 50px;height: 50px;line-height: 50px;border-radius: 50%;background-color: #172c64;text-align: center;font-size:15px;">签退</div></td>
                        <td style="background: #172d64;height:32px;">${data.afternoonSignOffTime}</td>
                        <td style="background: #172d64;height:32px;">${data.afternoonSignOffLocation}</td>
                        <td style="background: #172d64;height:32px;text-align: center;"">${data.afternoonSignOffAttendanceType}</td>
                    </tr>
                </table>
            </div>
        </div>`
                    infoWindow = new AMap.InfoWindow({
                        content: info, //使用默认信息窗体框样式，显示信息内容
                    })
                    infoWindow.open(map, e.lnglat)
                })
                //         var info = `<div class='mapUserInfoBox' style='padding:0px 0px 0px 4px;width:280px'>
                //                                 开始时间：<input id='s${item.id}date' class="Wdate" type="text" onClick="WdatePicker({el:this,dateFmt:'yyyy-MM-dd HH:mm:ss'})">
                //                                 结束时间：<input id='e${item.id}date' class="Wdate" type="text" onClick="WdatePicker({el:this,dateFmt:'yyyy-MM-dd HH:mm:ss'})">
                //                                     <b>
                //                                     人员名称：${data.name}
                //                                     </b><br/>
                //                                     // <ul id='u${item.id}'>
                //                                     <li>签到时间(上午): ${data.morningSignInTime}</li>
                //                                     <li>签退时间(上午): ${data.morningSignOffTime}</li>
                //                                     <li>签到状态(上午): ${data.morningSignInAttendanceType}</li>
                //                                     <li>签退状态(上午): ${data.morningSignInAttendanceType}</li>
                //                                     <li>签到位置(上午): ${data.morningSignInLocation}</li>
                //                                     <li>签退位置(上午): ${data.morningSignOffLocation}</li>
                //                                     <li>签到时间(下午): ${data.afternoonSignInTime}</li>
                //                                     <li>签退时间(下午): ${data.afternoonSignOffTime}</li>
                //                                     <li>签到状态(下午): ${data.afternoonSignInAttendanceType}</li>
                //                                     <li>签退状态(下午): ${data.afternoonSignOffAttendanceType}</li>
                //                                     <li>签到位置(下午): ${data.afternoonSignInLocation}</li>
                //                                     <li>签退位置(下午): ${data.afternoonSignOffLocation}</li>
                //                                     </ul>
                //                                     <div style='display:flex;justify-content: space-around;width:100%;'>
                //                                     <button onclick='getSearch${item.id}()' style='font-size:12px;width:100px;'>查询考勤记录</button></div>
                //                                     </div></div>`;
                // let f = "getSearch" + item.id;
                // window[f] = function() {
                //   //获取时间信息
                //   // var ulid = document.getElementById("u" + item.id)
                //   var sdate = document.getElementById("s" + item.id + "date").value;

                //   var edate = document.getElementById("e" + item.id + "date").value;
                //   console.log(sdate);
                //   console.log(edate);
                //   // console.log(ulid);
                //   if (sdate == "" && edate == "") {
                //   } else if (sdate != "" && edate != "") {
                //     post("/admin/attendanceRecord/info/list", {
                //       id: item.id,
                //       // attendanceMapType: 2,
                //       startTime: sdate,
                //       endTime: edate,
                //       pageNo: 1,
                //       pageSize: 999
                //     }).then(res => {
                //       console.log(res);
                //       console.log(item.id);
                //       document.getElementById("u" + item.id).innerHTML = "";
                //         var l = document.createElement("li");
                //         var l1 = document.createElement("li");
                //         var l2 = document.createElement("li");
                //         var l3 = document.createElement("li");
                //         var l4 = document.createElement("li");
                //         var l5 = document.createElement("li");
                //         var l6 = document.createElement("li");
                //         var l7 = document.createElement("li");
                //         var l8 = document.createElement("li");
                //         var l9 = document.createElement("li");
                //         var l10 = document.createElement("li");
                //         var l11 = document.createElement("li");
                //         // console.log(data)
                //         // console.log(item)
                //         for (let x in item){
                //           if (item[x] == null) {
                //             item[x] = ""
                //           }}
                //         console.log(item)
                //         l.innerHTML = `签到时间(上午)：${item.morningSignInTime}`;
                //         l1.innerHTML = `签退时间(上午)：${item.morningSignOffTime}`;
                //         l2.innerHTML = `签到状态(上午)：${item.morningSignInAttendanceType}`;
                //         l3.innerHTML = `签退状态(上午)：${item.morningSignInAttendanceType}`;
                //         l4.innerHTML = `签到位置(上午)：${item.morningSignInLocation}`;
                //         l5.innerHTML = `签退位置(上午)：${item.morningSignOffLocation}`;
                //         l6.innerHTML = `签到时间(下午)：${item.afternoonSignInTime}`;
                //         l7.innerHTML = `签退时间(下午)：${item.afternoonSignOffTime}`;
                //         l8.innerHTML = `签到状态(下午)：${item.afternoonSignInAttendanceType}`;
                //         l9.innerHTML = `签退状态(下午)：${item.afternoonSignOffAttendanceType}`;
                //         l10.innerHTML = `签到位置(下午)：${item.afternoonSignInLocation}`;
                //         l11.innerHTML = `签退位置(下午)：${item.afternoonSignOffLocation}`;
                //         var ul = document.getElementById("u" + item.id)
                //         console.log(ul)
                //         ul.appendChild(l)
                //         ul.appendChild(l1)
                //         ul.appendChild(l2)
                //         ul.appendChild(l3)
                //         ul.appendChild(l4)
                //         ul.appendChild(l5)
                //         ul.appendChild(l6)
                //         ul.appendChild(l7)
                //         ul.appendChild(l8)
                //         ul.appendChild(l9)
                //         ul.appendChild(l10)
                //         ul.appendChild(l11)
                //         console.log(ul)
                //     });
                //   }
                // };
            })
        })
    },
    created() {
        let that = this
        that.getAttendanceRecordStatisticsByMap()
        post("/rbac/admin/org/info/OrgTreelist", {
            orgType: 1,
            isValid: 1,
        }).then((res) => {
            this.orgList = res.content
        })
    },
}
</script>

<style lang="less" scoped>
/deep/.amap-marker-content {
    min-width: 40px;
    /deep/p {
        color: #fff;
        font-size: 12px;
        text-align: center;
    }
    /deep/svg {
        display: block;
        margin: 0 auto;
    }
}
.el-tag {
    line-height: 20px;
    height: 20px;
    margin: 0px 10px;
    cursor: pointer;
}
</style>

